import { DATE_WEEKDAY_ABBR_FORMAT } from '../../../constants/date'
import { formatDate } from '../../Table'

export function getViewingDateCellDateLabel({ locale, start, timezone }) {
  return formatDate({
    date: start,
    dateFormat: DATE_WEEKDAY_ABBR_FORMAT,
    locale,
    timezone,
    useTodayFormat: false,
  })
}
